import { getUID } from '@redviking/argonaut-util/src/getUID';
import { getAllAppletVariables } from '@redviking/argonaut-util/src/mes/appletUtil';
import type { UiNodeSpec } from './UiNodeSpec';
import { createNodeSocket } from '../../sync-utils/create-node-socket';
import type { NodeCfg } from '@redviking/argonaut-util/types/mes/applet-designs/flow.latest';
import { getSocketTypeForVarId } from '../socket-var-helpers';

export const varReadUiNodeSpec: UiNodeSpec<'varRead'> = {
    requiredSockets: 'all',
    cfg: () => ({ controlValues: { varId: '' }, id: getUID(), kind: 'varRead', disabled: false }),
    controls: getNodeCfg => ({
        varId: {
            cfg: {
                kind: 'selectVar',
                allVars: true,
                onSelect: val => {
                    const nodeCfg = getNodeCfg();
                    const controlValues: NodeCfg<'varRead'>['controlValues'] = {
                        ...nodeCfg.controlValues,
                        varId: val,
                    };
                    const newNodeCfg = {
                        ...nodeCfg,
                        controlValues,
                    };
                    createNodeSocket({
                        newNodeCfg,
                    });
                    
                },
            },
            nodeCfg: getNodeCfg(),
            value: getNodeCfg().controlValues.varId,
        },
    }),
    inputs: () => ({}),
    kindLabel: 'Variable Read',
    nodeCategory: 'variable',
    outputs: (nodeCfg) => ({ value: { socket: getSocketTypeForVarId(nodeCfg.controlValues.varId), label: 'Value' } }),
    validator: (node, appletDesignVersionConfig) => {
        const errors: Record<string, string> = {};
        if (!node.controlValues.varId) {
            errors.varId = 'Variable is required';
        }
        const allAppletVariables = getAllAppletVariables(appletDesignVersionConfig);
        if (!allAppletVariables[node.controlValues.varId]) {
            errors.varId = 'Variable is not a valid variable';
        }
        return Object.keys(errors).length ? errors : true;
    },
};
